import React, { forwardRef } from 'react';
import type { ActionItemProps, ActionListProps } from './ActionList.typed';
import * as Styled from './ActionList.styled';
import { ActionLinkItemProps } from './ActionList.typed';

const ActionList = forwardRef<HTMLUListElement, ActionListProps>(
  ({ children, ...rest }, ref) => (
    <Styled.ActionList ref={ref} {...rest}>
      {children}
    </Styled.ActionList>
  ),
);

const Item = React.forwardRef<HTMLButtonElement, ActionItemProps>(
  (props, ref) => {
    const {
      isSelected = false,
      leading,
      trailing,
      children,
      disabled = false,
      ...rest
    } = props;
    return (
      <li>
        <Styled.ActionItem
          ref={ref}
          as={'button'}
          role="option"
          disabled={disabled}
          isSelected={isSelected}
          aria-selected={isSelected}
          {...rest}
        >
          {!!leading && <Styled.Leading>{leading}</Styled.Leading>}
          {children}
          {!!trailing && <Styled.Trailing>{trailing}</Styled.Trailing>}
        </Styled.ActionItem>
      </li>
    );
  },
);
const LinkItem = React.forwardRef<HTMLAnchorElement, ActionLinkItemProps>(
  (props, ref) => {
    const {
      isSelected = false,
      disabled = false,
      target,
      href,
      ...rest
    } = props;
    return (
      <li>
        <Styled.ActionItem
          as={'a'}
          ref={ref}
          disabled={disabled}
          isSelected={isSelected}
          {...(disabled
            ? { 'aria-disabled': true, role: 'link' }
            : { href, target, role: 'option' })}
          {...rest}
        />
      </li>
    );
  },
);
const Divider = () => <Styled.ActionDivider aria-hidden={true} />;

export default Object.assign(ActionList, {
  Item,
  LinkItem,
  Divider,
});
